import { createSortOption } from "@nosto/preact"
export const sizes = [24, 48, 72]

export const desktopExpandedFacets = ['Tea Type', 'Caffeine', 'Unit', 'Price', 'Packaging Type', 'Preferences']

export const sortOptions = [
    createSortOption("score", "Best Selling", { field: "score", order: "desc" }),
    createSortOption("price", "Price, low to high", { field: "price", order: "asc" }),
    createSortOption("alphabetical", "Alphabetical, A-Z", { field: "name", order: "asc" }),
    createSortOption("-alphabetical", "Alphabetical, Z-A", { field: "name", order: "desc" }),
    createSortOption("-date", "Newest", { field: "datePublished", order: "desc" }),
    createSortOption("date", "Oldest", { field: "datePublished", order: "asc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 6,
    autocompleteKeywordsSize: 8,
    historySize: 6
}

export const customFacets = [
    {
        name: 'Availability',
        custom: {
            true: 'In Stock',
            false: false,
        },
    },
]
